import { RevenueChart, RevenueChartProps } from '../revenue-chart';

import { BasicTooltipContentFormatterWrapper } from '../tool-tip-content-formatters/basic';

export const ChartOnlyLayout = ({ data, initialTab }: RevenueChartProps) => {
  return (
    <RevenueChart
      data={data}
      initialTab={initialTab}
      tooltipContentFormatter={BasicTooltipContentFormatterWrapper(initialTab)}
    />
  );
};
